module.exports = __webpack_public_path__ + "static/media/alfa.beb3c3fa.svg";